
import React from 'react';

const PracticesSection: React.FC = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-teal-50 to-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="bg-white rounded-3xl shadow-2xl p-12 relative overflow-hidden">
          {/* Badge superior */}
          <div className="text-center mb-8">
            <div className="inline-flex items-center px-4 py-2 bg-yellow-100 text-yellow-800 rounded-full text-sm font-medium">
              <i className="ri-star-fill mr-2"></i>
              Oportunidad Exclusiva
            </div>
          </div>
          
          {/* Título principal */}
          <h2 className="text-4xl lg:text-5xl font-extrabold text-gray-900 text-center mb-8">
            ¡Completa tu formación con prácticas reales!
          </h2>
          
          {/* Descripción */}
          <p className="text-xl text-gray-600 text-center mb-12 leading-relaxed max-w-3xl mx-auto">
            Al finalizar el curso, te ofrecemos gestión completa de prácticas en clínicas veterinarias reales. 
            Incluye seguro de responsabilidad civil y todos los trámites administrativos.
          </p>
          
          {/* Contenedor de precio destacado */}
          <div className="border-3 border-teal-500 rounded-2xl p-8 max-w-md mx-auto">
            <div className="text-center">
              <div className="mb-6">
                <span className="text-lg text-gray-500">Solo</span>
                <div className="text-6xl font-bold text-teal-500 my-2">100€</div>
                <span className="text-lg text-gray-500">gestión completa</span>
              </div>
              
              {/* Lista de beneficios */}
              <div className="space-y-3">
                <div className="flex items-center justify-center text-teal-600">
                  <i className="ri-check-line text-xl mr-2"></i>
                  <span className="font-medium">Seguro incluido</span>
                </div>
                <div className="flex items-center justify-center text-teal-600">
                  <i className="ri-check-line text-xl mr-2"></i>
                  <span className="font-medium">Trámites gestionados</span>
                </div>
                <div className="flex items-center justify-center text-teal-600">
                  <i className="ri-check-line text-xl mr-2"></i>
                  <span className="font-medium">Clínicas verificadas</span>
                </div>
              </div>
            </div>
          </div>
          
          {/* Imagen de apoyo */}
          <div className="mt-12 rounded-2xl overflow-hidden">
            <img 
              src="https://public.readdy.ai/ai/img_res/aa30b6182cda2a484cfa05680f9df844.jpg"
              alt="Estudiante de veterinaria en prácticas"
              className="w-full h-48 object-cover"
            />
          </div>
          
          {/* Elementos decorativos */}
          <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-bl from-teal-100/50 to-transparent rounded-bl-3xl"></div>
          <div className="absolute bottom-0 left-0 w-32 h-32 bg-gradient-to-tr from-teal-100/50 to-transparent rounded-tr-3xl"></div>
        </div>
      </div>
    </section>
  );
};

export default PracticesSection;
